import React from 'react';
import { theme } from '../theme';
import { useTicketManager } from '../contexts/TicketManagerContext';

const ArchiveUndoToast: React.FC = () => {
  const { archiveUndo, undoArchive } = useTicketManager();
  if (!archiveUndo) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
      display: 'flex', alignItems: 'center', gap: theme.spacing.md,
      padding: `${theme.spacing.sm + 2}px ${theme.spacing.lg}px`,
      fontSize: 13, color: theme.colors.navy, fontFamily: theme.font.family,
      backgroundColor: theme.colors.white,
      border: `1px solid ${theme.colors.borderLight}`,
      borderRadius: theme.borderRadius.md,
      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
      zIndex: 1100,
      animation: 'stx-slideIn 0.2s ease',
    }}>
      <span>Ticket archiviert</span>
      <button
        onClick={undoArchive}
        style={{
          padding: '2px 10px', fontSize: 12, fontWeight: 600,
          fontFamily: theme.font.family,
          color: theme.colors.navy, backgroundColor: theme.colors.bgPage,
          border: `1px solid ${theme.colors.navy}`,
          borderRadius: theme.borderRadius.sm, cursor: 'pointer',
        }}
      >
        Rückgängig
      </button>
    </div>
  );
};

export default ArchiveUndoToast;
